// extracted by mini-css-extract-plugin
export default {"container":"HeaderWrapper_container__g1y5H","loading":"HeaderWrapper_loading__KgHMy"};